import { createSlice } from '@reduxjs/toolkit';
import { createAutomode, deleteAutomode, fetchAutomodes, updateAutomode } from './automode.actions';

const initialState = {
  automodes: [],
  metaData: { total: 0, page: 1, perPage: 10 },

  isLoadingCreateAutomode: false,
  isLoadingFetchAutomodes: false,
  isLoadingUpdateAutomode: false,
  isLoadingDeleteAutomode: false
};

const automodeSlice = createSlice({
  name: 'automode',
  initialState,
  reducers: {
    clearAutomodeState: () => initialState
  },
  extraReducers: (builder) => {
    builder.addCase(createAutomode.pending, (state) => {
      state.isLoadingCreateAutomode = true;
    });
    builder.addCase(createAutomode.fulfilled, (state) => {
      state.isLoadingCreateAutomode = false;
    });
    builder.addCase(createAutomode.rejected, (state) => {
      state.isLoadingCreateAutomode = false;
    });

    builder.addCase(fetchAutomodes.pending, (state) => {
      state.isLoadingFetchAutomodes = true;
    });
    builder.addCase(fetchAutomodes.fulfilled, (state, action) => {
      state.automodes = action.payload.data;
      state.metaData = action.payload.metaData;
      state.isLoadingFetchAutomodes = false;
    });
    builder.addCase(fetchAutomodes.rejected, (state) => {
      state.isLoadingFetchAutomodes = false;
    });

    builder.addCase(updateAutomode.pending, (state) => {
      state.isLoadingUpdateAutomode = true;
    });
    builder.addCase(updateAutomode.fulfilled, (state) => {
      state.isLoadingUpdateAutomode = false;
    });
    builder.addCase(updateAutomode.rejected, (state) => {
      state.isLoadingUpdateAutomode = false;
    });

    builder.addCase(deleteAutomode.pending, (state) => {
      state.isLoadingDeleteAutomode = true;
    });
    builder.addCase(deleteAutomode.fulfilled, (state) => {
      state.isLoadingDeleteAutomode = false;
    });
    builder.addCase(deleteAutomode.rejected, (state) => {
      state.isLoadingDeleteAutomode = false;
    });
  }
});

export const { clearAutomodeState } = automodeSlice.actions;

export default automodeSlice.reducer;
